import React from "react";

const ArrowInsertSvg = () => {
	return (
		<svg
			width="13"
			height="13"
			viewBox="0 0 13 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="fill-black dark:fill-white"
		>
			<title>Arrow insert</title>
			<path d="M11.144 2.80375V11C11.144 11.2125 11.216 11.3906 11.3598 11.5343C11.5036 11.6781 11.6818 11.75 11.8943 11.75C12.107 11.75 12.285 11.6781 12.4285 11.5343C12.5722 11.3906 12.644 11.2125 12.644 11V1.15375C12.644 0.897751 12.5574 0.683084 12.384 0.50975C12.2109 0.336584 11.9962 0.25 11.74 0.25H1.89404C1.68154 0.25 1.50338 0.321917 1.35954 0.46575C1.21588 0.609583 1.14404 0.78775 1.14404 1.00025C1.14404 1.21292 1.21588 1.391 1.35954 1.5345C1.50338 1.67817 1.68154 1.75 1.89404 1.75H10.0903L0.767042 11.0828C0.628709 11.2213 0.561127 11.3953 0.564293 11.6048C0.567459 11.8144 0.638292 11.9885 0.776793 12.127C0.915126 12.2653 1.08754 12.3345 1.29404 12.3345C1.50038 12.3345 1.67279 12.2653 1.81129 12.127L11.144 2.80375Z" />
		</svg>
	);
};

export default ArrowInsertSvg;
